"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _link = require("../../constants/link");

var _hubl = require("../../utils/hubl");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  vertical-align: middle;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var MAX_WIDTH = 175;
var PreviewLink = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "LinkPreview__PreviewLink",
  componentId: "sc-1w4nj77-0"
})(_templateObject());

var LinkPreview =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkPreview, _Component);

  function LinkPreview() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkPreview)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handlePreviewLinkClick = function (evt) {
      var _this$props = _this.props,
          href = _this$props.href,
          linkType = _this$props.linkType,
          onAnchorPreviewClick = _this$props.onAnchorPreviewClick;

      if (linkType === _link.LinkTypes.ANCHOR && onAnchorPreviewClick) {
        onAnchorPreviewClick(href);
        evt.preventDefault();
      }
    };

    return _this;
  }

  (0, _createClass2.default)(LinkPreview, [{
    key: "renderEmailSubscriptionLink",
    value: function renderEmailSubscriptionLink() {
      var _this$props2 = this.props,
          linkDisplayName = _this$props2.linkDisplayName,
          className = _this$props2.className;
      return _react.default.createElement(_UIBox.default, {
        className: className
      }, _react.default.createElement(_UIFormLabel.default, {
        className: "p-y-0 p-x-0"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey("previewLabel.email_subscription")
      }), ' ', linkDisplayName));
    }
  }, {
    key: "renderHublLink",
    value: function renderHublLink() {
      var _this$props3 = this.props,
          href = _this$props3.href,
          className = _this$props3.className;
      return _react.default.createElement(_UIBox.default, {
        className: className
      }, _react.default.createElement(_UIFormLabel.default, {
        className: "p-y-0 p-x-0 link-preview-form-label"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey("previewLabel.url")
      })), ' ', _react.default.createElement("span", {
        style: {
          display: 'inline-block',
          verticalAlign: 'middle'
        }
      }, _react.default.createElement(_UITruncateString.default, {
        useFlex: true,
        maxWidth: MAX_WIDTH,
        tooltip: false
      }, href)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          linkType = _this$props4.linkType,
          linkDisplayName = _this$props4.linkDisplayName,
          href = _this$props4.href,
          className = _this$props4.className;

      if (linkType === _link.LinkTypes.EMAIL_SUBSCRIPTION) {
        return this.renderEmailSubscriptionLink();
      } else if ((0, _hubl.hasHublVariable)(href)) {
        return this.renderHublLink();
      }

      return _react.default.createElement(_UIBox.default, {
        className: className
      }, _react.default.createElement(_UIFormLabel.default, {
        className: "p-y-0 p-x-0 p-right-2 link-preview-form-label"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey("previewLabel." + linkType)
      })), _react.default.createElement(PreviewLink, {
        external: linkType !== _link.LinkTypes.ANCHOR,
        href: href,
        truncate: true,
        truncateStringProps: {
          maxWidth: MAX_WIDTH,
          tooltip: false
        },
        onClick: this.handlePreviewLinkClick
      }, linkDisplayName));
    }
  }]);
  return LinkPreview;
}(_react.Component);

exports.default = LinkPreview;
LinkPreview.propTypes = {
  href: _react.PropTypes.string.isRequired,
  linkDisplayName: _react.PropTypes.string.isRequired,
  linkType: _react.PropTypes.string.isRequired,
  className: _react.PropTypes.string,
  onAnchorPreviewClick: _react.PropTypes.func
};
module.exports = exports.default;